import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetInvoices, GetInvoicesModel, GetInvoicesParams} from 'domain/usecases';

export class RemoteGetInvoices implements GetInvoices {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetInvoicesModel>,
	) {}

	async get(params?: GetInvoicesParams): Promise<GetInvoicesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal: params?.signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
